import { render, staticRenderFns } from "./overlay-loading.vue?vue&type=template&id=184d369c&"
import script from "./overlay-loading.vue?vue&type=script&lang=js&"
export * from "./overlay-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports